import React from 'react'

import { Card, ProgressBar } from '../ui-blocks'


export const CourseCard = ({ course }) => {

  const { status, progress } = course.learnerCourse

  const isCompleted = (status === 'completed')

  const { buttonLabel, actionUrl } = isCompleted ? {
    buttonLabel: null,
    actionUrl: course.link
  } : {
      buttonLabel: (status === 'not-started') ? 'Start' : 'Continue',
      actionUrl: (course.learnerCourse.nextStep) ? course.learnerCourse.nextStep.url : course.link
    }


  return (
    <Card imageProps={course.featuredMedia?.previewUrl ? {
      src: course.featuredMedia?.previewUrl,
      alt: 'Media Preview'
    } : {}}>

      <h3 className="course-card-title">{course.title}</h3>
      <p className="course-card-byline">By {course.author.title}</p>

      {(course.teamSize || course.level) && (
        <dl className="course-card-facts">
          {course.teamSize && (<div><dt>Team size</dt><dd>{course.teamSize}</dd></div>)}
          {course.level && (<div><dt>Skill level</dt><dd>{course.level}</dd></div>)}
        </dl>
      )}

      {!!course.specialties.length && (
        <div className="mb-3">
          {course.specialties.map(specialty => (
            <span key={specialty.id} className="course-card-chip">
              {specialty.name}
            </span>
          ))}
        </div>
      )}

      {(!isCompleted && progress) && (
        <div className="mb-3">
          <ProgressBar current={progress.completed} maximum={progress.total} />
          <div className="course-card-progress">{progress.completed} of {progress.total} steps done</div>
        </div>
      )}

      <div className="text-center">
        {isCompleted ? (
          <a
            className="bg-success text-white rounded py-2 px-3 d-inline-block stretched-link text-decoration-none"
            href={actionUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            You finished this course
          </a>
        ) : (
            <a className="btn btn-primary stretched-link" href={actionUrl} target="_blank" rel="noopener noreferrer">
              { buttonLabel}
            </a>
          )}
      </div>

    </Card>
  )
}
